/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: process.env.REACT_APP_AWS_REGION, //"us-east-1",
  // aws_appsync_graphqlEndpoint:
  //  "https://wt6kgwdfbvectbfcxicyrezp3m.appsync-api.us-east-1.amazonaws.com/graphql",
  // aws_appsync_region: process.env.REACT_APP_AWS_REGION, //"us-east-1",
  // aws_appsync_authenticationType: "API_KEY",
  // aws_appsync_apiKey: "da2-gfd3txu7jjhlzlem7cuycnq4zy",
  aws_cognito_identity_pool_id: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID, //"us-east-2:7b1b1b1b-1b1b-1b1b-1b1b-1b1b1b1b1b1b",
  aws_cognito_region: process.env.REACT_APP_AWS_REGION, //"us-east-2",
  aws_user_pools_id: process.env.REACT_APP_COGNITO_USER_POOL_ID, //"us-east-2_QHNG7Vtqy",
  aws_user_pools_web_client_id:
    process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID, //,"47fd9jksugaa9l9rvi1llrm4cb",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;
